/*
 * locale-links.js — keep shoppers inside their market subfolder.
 *
 * Market subfolders went live 2026-10-26 (arteriel.com/en-ca, /en-au). Liquid
 * links go through snippets/locale-path; links built in JavaScript (concierge,
 * AI search, Algolia, recommendations) and links in merchant rich text are
 * root-relative. This prefixes a storefront navigation with the subfolder at
 * the moment it is followed (click, middle-click, keyboard Enter), and exposes
 * window.arterielLocalePath for code that navigates directly.
 *
 * Only storefront PAGES are rewritten. Data endpoints (/cart.js, /products/x.js,
 * App Proxy APIs) follow the market cookie and work from the root; sign-in,
 * checkout and CDN paths are left to Shopify.
 */
(function () {
  var PAGE = /^\/(?:products|collections|pages|blogs|search|cart|policies|apps\/arteriel\/(?:trade|spaces))(?:[/?#]|$)/;
  var DATA = /\.(?:js|json|xml|oembed)(?:[?#]|$)/;

  function marketBase() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root || root === "/") return "";
    return root.replace(/\/$/, "");
  }

  function localePath(path) {
    var base = marketBase();
    if (!base || typeof path !== "string") return path;
    if (path === base || path.indexOf(base + "/") === 0 || path.indexOf(base + "?") === 0) return path;
    if (!PAGE.test(path) || DATA.test(path)) return path;
    return base + path;
  }

  function onFollow(e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a || a.hasAttribute("download")) return;
    var href = a.getAttribute("href");
    var next = localePath(href);
    if (next !== href) a.setAttribute("href", next);
  }

  window.arterielLocalePath = localePath;
  // Capture phase: rewrite before any handler or the browser follows the link.
  document.addEventListener("click", onFollow, true);
  document.addEventListener("auxclick", onFollow, true);
})();
